/**
 * Hydrates "You may also like" with diverse brands: same type when possible,
 * one product per vendor, never the current product's brand.
 */
(function () {
  var JSON_LIMIT = 250;

  function shopBaseUrl() {
    var r =
      (typeof window !== 'undefined' && window.routes && window.routes.root_url) ||
      (typeof window !== 'undefined' &&
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '';
    r = String(r || '').trim();
    if (!r) {
      return typeof window !== 'undefined' ? window.location.origin + '/' : '/';
    }
    return r.endsWith('/') ? r : r + '/';
  }

  function collectionProductsJsonUrl(handle, page) {
    var path =
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      JSON_LIMIT +
      '&page=' +
      page +
      '&sort_by=best-selling';
    var base = shopBaseUrl();
    try {
      return new URL(path, base).href;
    } catch (_e) {
      return path.indexOf('/') === 0 ? path : '/' + path;
    }
  }

  function fetchAllProducts(handle) {
    var all = [];
    var page = 1;

    function next() {
      return fetch(collectionProductsJsonUrl(handle, page))
        .then(function (r) {
          if (!r.ok) throw new Error('products.json ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          for (var i = 0; i < batch.length; i++) all.push(batch[i]);
          if (batch.length < JSON_LIMIT) return all;
          page += 1;
          return next();
        });
    }

    return next();
  }

  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function productTags(p) {
    var tags = p && p.tags;
    if (!tags) return [];
    if (Array.isArray(tags)) return tags;
    return String(tags)
      .split(',')
      .map(function (t) {
        return handleize(t);
      })
      .filter(Boolean);
  }

  function sharesTag(p, primaryTag) {
    if (!primaryTag) return false;
    var tags = productTags(p);
    for (var i = 0; i < tags.length; i++) {
      if (tags[i] === primaryTag) return true;
    }
    return false;
  }

  function pickDiverseHandles(products, opts) {
    var limit = opts.limit;
    var productId = opts.productId;
    var vendorKey = opts.vendorKey;
    var typeKey = opts.typeKey;
    var primaryTag = opts.primaryTag;
    var seen = Object.create(null);
    var handles = [];

    function tryAdd(p, requireType, requireTag) {
      if (!p || !p.handle || handles.length >= limit) return;
      if (productId && p.id === productId) return;
      var vk = String(p.vendor || '')
        .toLowerCase()
        .trim();
      if (!vk || vk === vendorKey || seen[vk]) return;
      if (requireType && typeKey && handleize(p.product_type) !== typeKey) return;
      if (requireTag && primaryTag && !sharesTag(p, primaryTag)) return;
      seen[vk] = true;
      handles.push(p.handle);
    }

    for (var i = 0; i < products.length && handles.length < limit; i++) {
      if (typeKey) tryAdd(products[i], true, false);
    }
    for (var j = 0; j < products.length && handles.length < limit; j++) {
      if (primaryTag) tryAdd(products[j], false, true);
    }
    for (var k = 0; k < products.length && handles.length < limit; k++) {
      tryAdd(products[k], false, false);
    }

    return handles;
  }

  function wakeSlider(root) {
    var sliderComponent = root.querySelector('slider-component');
    if (!sliderComponent) return;
    if (typeof sliderComponent.syncScrollPort === 'function') {
      sliderComponent.syncScrollPort();
    }
    if (typeof sliderComponent.initPages === 'function') {
      sliderComponent.initPages();
    }
    if (typeof sliderComponent.update === 'function') {
      sliderComponent.update();
    }
  }

  function init(root) {
    if (!root || root.dataset.skippTypeRecsReady === '1') return;
    if (root.querySelector('.product-grid .grid__item')) {
      root.dataset.skippTypeRecsReady = '1';
      wakeSlider(root);
      return;
    }

    var handle = root.dataset.catalogHandle || 'all';
    var typeKey = handleize(root.dataset.productType);
    var primaryTag = handleize(root.dataset.productPrimaryTag);
    var vendorKey = String(root.dataset.productVendor || '')
      .toLowerCase()
      .trim();
    var productId = parseInt(root.dataset.productId, 10);
    var sectionId = root.dataset.sectionId;
    var limit = parseInt(root.dataset.limit, 10) || 10;

    if (!sectionId) return;

    fetchAllProducts(handle)
      .then(function (products) {
        var handles = pickDiverseHandles(products, {
          limit: limit,
          productId: productId,
          vendorKey: vendorKey,
          typeKey: typeKey,
          primaryTag: primaryTag,
        });
        if (!handles.length) return;

        var params = new URLSearchParams();
        params.set('section_id', sectionId);
        params.set('skipp_type_rec_handles', handles.join(','));
        var url = window.location.pathname + '?' + params.toString();
        return fetch(url).then(function (r) {
          return r.ok ? r.text() : '';
        });
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-skipp-type-recs]');
        if (!fresh) return;
        var slider = fresh.querySelector('[data-skipp-pdp-rail-slider]');
        if (!slider || !slider.querySelector('.product-grid .grid__item')) return;
        var heading = root.querySelector('.related-products__heading');
        if (!heading && fresh.querySelector('.related-products__heading')) {
          root.insertAdjacentHTML('afterbegin', fresh.querySelector('.related-products__heading').outerHTML);
        }
        var existing = root.querySelector('[data-skipp-pdp-rail-slider]');
        if (existing) {
          existing.replaceWith(slider);
        } else {
          root.appendChild(slider);
        }
        root.dataset.skippTypeRecsReady = '1';
        wakeSlider(root);
        document.dispatchEvent(new CustomEvent('skipp:collection-delivery-split'));
      })
      .catch(function () {
        /* silent */
      });
  }

  function boot() {
    document.querySelectorAll('[data-skipp-type-recs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
